export enum CompanyLockUpPeriodRowsName {
  Date = 'Date',
  Shares = 'Shares',
  DaysToLockup = 'Days to Lock-Up',
}
